import { FC, SVGProps } from 'react'

const LogoutIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 0H16V16H0V11H2V14H14V2H2V5H0V0ZM6.16667 9H0V7H6.33333L6.16667 9Z"
      fill="currentColor"
    />
    <path d="M10.1667 7.8319L6.16667 11.832V3.83186L10.1667 7.8319Z" fill="currentColor" />
  </svg>
)

export default LogoutIcon
